<template>
  <main class="dashboard">
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header class="pa-0 font-bold filter">
          <v-container>
            <v-icon>mdi-filter</v-icon>
          </v-container>
        </v-expansion-panel-header>
        <v-expansion-panel-content class="px-0">
          <InputFilter class="pt-10" :pagination="pagination" />
          <section class="filter-area">
            <v-container class="py-0">
              <v-row>
                <v-col cols="12" sm="10" class="mx-auto py-0">
                  <v-row justify="space-between" no-gutters>
                    <v-col cols="12" sm="2" class="camp-type py-0">
                      <v-autocomplete
                        :items="statuses"
                        item-text="name"
                        item-value="id"
                        label="Statuses"
                        dense
                        filled
                        :append-icon="filter.statuses ? 'mdi-close' : ''"
                        @click:append="clearSearchData('statuses')"
                        v-model="filter.statuses"
                        @change="filterStatus"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2" class="gender py-0">
                      <v-autocomplete
                        :items="appTypes"
                        item-text="name"
                        item-value="id"
                        label="App Type"
                        dense
                        filled
                        :append-icon="filter.type ? 'mdi-close' : ''"
                        @click:append="clearSearchData('type')"
                        v-model="filter.type"
                        @change="filterTypes"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2" class="location py-0">
                      <v-autocomplete
                        :items="religions"
                        item-text="name"
                        item-value="id"
                        label="Religions"
                        dense
                        filled
                        :append-icon="filter.religions ? 'mdi-close' : ''"
                        @click:append="clearSearchData('religions')"
                        v-model="filter.religions"
                        @change="filterReligion"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="2" class="month py-0">
                      <v-menu
                        ref="menu1"
                        v-model="menu1"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="filter.from"
                            label="From"
                            filled
                            dense
                            persistent-hint
                            :append-icon="filter.from ? 'mdi-close' : ''"
                            @click:append="clearSearchData('from')"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="filter.from"
                          no-title
                          @input="filterDate"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="2" class="year py-0">
                      <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="filter.to"
                            label="To"
                            filled
                            dense
                            persistent-hint
                            :append-icon="filter.to ? 'mdi-close' : ''"
                            @click:append="clearSearchData('to')"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="filter.to"
                          no-title
                          @input="filterDateTo"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </section>
          <v-container>
            <v-row class="mt-5">
              <v-col cols="12" sm="6" md="6" lg="2">
                <section
                  class="text-center px-1 py-6 radius-12 dashboard__intro warning"
                >
                  <p class="mb-0">Pending Applicants</p>
                  <h2>{{ statistics.total_pending_applicants || "" }}</h2>
                </section>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="2">
                <section
                  class="text-center px-1 py-6 radius-12 dashboard__intro dashboard__intro__4"
                >
                  <p class="mb-0">Shortlisted</p>
                  <h2>{{ statistics.total_shortlisted_applicants }}</h2>
                </section>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="2">
                <section
                  class="text-center px-1 py-6 radius-12 dashboard__intro dashboard__intro__1"
                >
                  <p class="mb-0">Shortlist Others</p>
                  <h2>{{ statistics.total_shortlist_others || 0 }}</h2>
                </section>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="2">
                <section
                  class="text-center px-1 py-6 radius-12 dashboard__intro dashboard__intro__1"
                >
                  <p class="mb-0">Waiting Interview</p>
                  <h2>{{ statistics.total_waiting_interview || 0 }}</h2>
                </section>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="2">
                <section
                  class="text-center px-1 py-6 radius-12 dashboard__intro dashboard__intro__4"
                >
                  <p class="mb-0">Interview Requested</p>

                  <h2>{{ statistics.total_interview_applicants }}</h2>
                </section>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="2">
                <section
                  class="text-center px-1 py-6 radius-12 dashboard__intro dashboard__intro__1"
                >
                  <p class="mb-0">Waiting Training</p>
                  <h2>{{ statistics.total_waiting_training || 0 }}</h2>
                </section>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="2">
                <section
                  class="text-center px-1 py-6 radius-12 dashboard__intro dashboard__intro__4"
                >
                  <p class="mb-0">Training</p>
                  <h2>{{ statistics.total_training_applicants }}</h2>
                </section>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="2">
                <section
                  class="text-center px-1 py-6 radius-12 dashboard__intro dashboard__intro__4"
                >
                  <p class="mb-0">Shadow Camp</p>
                  <h2>{{ statistics.total_shadow_camp_applicants }}</h2>
                </section>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="2">
                <section
                  class="text-center px-1 py-6 radius-12 dashboard__intro success"
                >
                  <p class="mb-0">Accepted</p>
                  <h2>{{ statistics.total_accepted_applicants }}</h2>
                </section>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="2">
                <section
                  class="text-center px-1 py-6 radius-12 dashboard__intro error"
                >
                  <p class="mb-0">Rejected</p>
                  <h2>{{ statistics.total_rejected_applicants }}</h2>
                </section>
              </v-col>

              <v-col cols="12" sm="6" md="6" lg="2">
                <section
                  class="text-center px-1 py-6 radius-12 dashboard__intro dashboard__intro__1"
                >
                  <p class="mb-0">Total Applicants</p>
                  <h2>{{ statistics.total_applicants || "" }}</h2>
                </section>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="2">
                <section
                  class="text-center px-1 py-6 radius-12 dashboard__intro"
                  style="height: 100%; position: relative"
                >
                  <v-btn
                    v-if="!downloading"
                    class="text-capitalize"
                    large
                    rounded
                    color="error"
                    outlined
                    @click="handleSave()"
                    width="100%"
                    height="100%"
                    ><span>Export</span>
                  </v-btn>
                  <v-btn
                    class="text-capitalize"
                    large
                    rounded
                    width="100%"
                    height="100%"
                    color="success"
                    outlined
                    v-else
                    :href="url"
                    @click="download"
                    >Download</v-btn
                  >
                </section>
              </v-col>
            </v-row>
          </v-container>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-container>
      <h1 class="d-flex justify-space-between w-100 mt-12">
        <span>Applicants List</span
        ><router-link to="/hr/dashboard/filter-application"
          ><small class="size-20">Advanced Search</small></router-link
        >
      </h1>
      <v-row v-if="apps.length > 0">
        <v-col
          cols="12"
          sm="6"
          md="6"
          lg="3"
          v-for="app in apps"
          :key="app.index"
        >
          <v-card
            class="radius-12 px-2 pt-3 pb-10 global-card global-card__except dashboard__card"
          >
            <div class="d-flex flex-no-wrap justify-space-between">
              <v-avatar
                style="cursor: pointer"
                @click.stop="hanlePreviewImage(app.applicant.photo)"
                class="ma-3"
                size="70"
                tile
              >
                <v-img :src="app.applicant.photo"></v-img>
              </v-avatar>
              <router-link
                :to="{
                  name: 'dashboardApplicant',
                  params: { id: app.id },
                }"
              >
                <section>
                  <h5 class="color-black">
                    {{ app.applicant.full_name || "---" }}
                  </h5>

                  <v-card-subtitle class="pa-0 l-h-1"
                    ><small>{{
                      app.applicant.email || "---"
                    }}</small></v-card-subtitle
                  >
                  <v-card-subtitle class="pa-0 l-h-1"
                    ><small>{{
                      app.applicant.mobile || "---"
                    }}</small></v-card-subtitle
                  >
                  <v-card-subtitle class="pa-0 l-h-1"
                    ><small>{{
                      app.applicant.type.name || "---"
                    }}</small></v-card-subtitle
                  >
                  <v-card-subtitle v-if="app.applicant.about" class="pa-0 l-h-1"
                    ><small>{{ app.applicant.about }}</small></v-card-subtitle
                  >
                  <v-card-subtitle class="pa-0 l-h-1"
                    ><small>{{ app.serial }}</small></v-card-subtitle
                  >
                  <v-card-subtitle class="pa-0 l-h-1"
                    ><small>{{
                      app.signed_at ? app.signed_at.date : ""
                    }}</small></v-card-subtitle
                  >
                  <v-chip
                    class="mt-3 dashboard__card-status"
                    :class="app.status.name || 'default'"
                    small
                    >{{ app.status.name || "---" }}</v-chip
                  >
                </section>
              </router-link>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <p v-else>No Applicant Found</p>
      <div class="text-xs-center pt-2">
        <v-pagination
          v-if="apps.length > 0 && pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="20"
          @input="handlePagination"
        ></v-pagination>
      </div>
      <!-- pagination -->
    </v-container>
    <v-dialog max-width="400" v-model="dialog">
      <v-card max-width="400">
        <v-card-text>
          <v-img :src="dialogImage" alt="photo"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" block large rounded @click="dialog = !dialog"
            >close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </main>
</template>

<script>
import { IndexData } from "@/helpers/apiMethods";
import { isEqual } from "lodash";

export default {
  data() {
    return {
      dialog: false,
      apps: [],
      appTypes: [],
      statuses: [],
      religions: [],
      filter: {
        statuses: "",
        type: "",
        from: "",
        to: "",
        religions: "",
      },
      menu1: false,
      menu2: false,
      statistics: {},
      pagination: {},
      queries: {},
      url: {},
      downloading: false,
      dialogImage: "",
    };
  },
  components: {
    InputFilter: () => import("@/views/accounts/components/InputFilter"),
  },
  created() {
    this.indexStatuses();
    this.indexStatistics();
    this.indexAppTypes();
    this.indexReligions();
  },
  methods: {
    hanlePreviewImage(image) {
      this.dialog = !this.dialog;
      this.dialogImage = image;
    },
    handleSave() {
      IndexData({
        reqName: `hr/dashboard/applications-download`,
        query: { ...this.$route.query },
      })
        .then((res) => {
          this.url = res.data.url;

          this.downloading = true;
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        });
    },
    download() {
      this.downloading = false;
      this.form = {};
    },
    indexApps(query) {
      IndexData({ reqName: `hr/dashboard/applications`, query })
        .then((res) => {
          const { data, meta } = res.data;
          this.apps = data;
          this.pagination = meta;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexStatistics() {
      IndexData({ reqName: `hr/dashboard/statistics` })
        .then((res) => {
          // const { data } = res.data;
          this.statistics = res.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexStatuses() {
      IndexData({ reqName: `hr/dashboard/application-statuses` })
        .then((res) => {
          this.statuses = res.data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexAppTypes() {
      IndexData({ reqName: `hr/dashboard/application-types` })
        .then((res) => {
          this.appTypes = res.data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexReligions() {
      IndexData({ reqName: `hr/dashboard/religions` })
        .then((res) => {
          this.religions = res.data.data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    handlePagination(page) {
      this.queries = { ...this.queries, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
    filterStatus(statuses) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({
        query: { ...routeQuery, statuses, page: 1 },
      });
    },
    filterTypes(type) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, type, page: 1 } });
    },
    filterReligion(religions) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, religions, page: 1 } });
    },
    filterDate(from) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, from, page: 1 } });
    },
    filterDateTo(to) {
      let routeQuery = { ...this.$route.query };
      this.$router.push({ query: { ...routeQuery, to, page: 1 } });
    },
    clearSearchData(name) {
      let routeQuery = { ...this.$route.query };
      this.filter[name] = "";
      delete routeQuery[name];
      this.$router.push({ query: routeQuery });
    },
  },
  watch: {
    $route: {
      handler(route) {
        const { query } = route;
        this.queries = query;
        this.pagination.current_page = query.page;
        // this.filter.month = query.month;
        // this.filter.year = query.year;
        // this.filter.available = query.available;
        this.filter.from = query.from;
        this.filter.to = query.to;
        if (query.statuses) {
          this.filter.statuses = Number(query.statuses);
        }
        if (query.type) {
          this.filter.type = Number(query.type);
        }
        if (query.religions) {
          this.filter.religions = Number(query.religions);
        }
        this.indexApps(query);
      },
      immediate: true,
    },
  },
};
</script>
